<script setup lang="ts">
import type { GraphqlDatatableColumn } from '~/components/GqlDatatable.vue';
import { computed, ref } from 'vue';
import gerentesSelect from '~/graphql/gerentesSelect.graphql';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  pastaCodigos?: string[];
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const mostrarHistoricoSolicitacoes = ref<string>('h');
const colunas: GraphqlDatatableColumn[] = [
  {
    key: 'compromisso',
    title: 'COMPROMISSO',
    width: 120,
  },
  {
    key: 'responsavel',
    title: 'RESPONSÁVEL',
    width: 120,
  },
  {
    dataIndex: 'dataInicioText',
    key: 'dataInicio',
    sortBy: ['dataInicio'],
    sorter: true,
    title: 'SOLICITADO EM',
    width: 120,
    defaultSortOrder: 'descend',
  },
  {
    dataIndex: 'dataVencimentoText',
    key: 'dataVencimento',
    sortBy: ['dataVencimento'],
    sorter: true,
    title: 'VENCIMENTO EM',
    width: 120,
  },
  {
    dataIndex: 'dataConclusaoText',
    key: 'dataConclusao',
    sortBy: ['dataConclusao'],
    sorter: true,
    title: 'CONCLUÍDO EM',
    width: 120,
  },
];

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  if (!props.compromisso) {
    return false;
  }
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});
</script>

<template>
  <CompromissoForm
    action="transferencia-responsavel-processual-para-outra-area/solicitar-transferencia-responsavel-processual-para-outra-area"
    :pasta-codigos="props.pastaCodigos ?? []"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :show-upload-files="true"
    :submit-button-disabled="buttonsDisabled"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-collapse
        v-if="props.pastaCodigos?.length === 1"
        v-model:active-key="mostrarHistoricoSolicitacoes"
        style="margin-bottom: 24px"
      >
        <a-collapse-panel key="h" header="HISTÓRICO DE SOLICITAÇÕES">
          <CompromissoGqlDatatable
            :columns="colunas"
            :show-dates-filter="false"
            :show-reload-button="false"
            :show-status-search-bar="false"
            :show-filter="false"
            :variables="{
              order: [{ dataInicio: 'DESC' }],
              where: {
                tipo: {
                  eq: 134,
                },
                fluxo: {
                  pastaCodigo: {
                    in: [props.pastaCodigos[0]],
                  },
                },
              },
            }"
          />
        </a-collapse-panel>
      </a-collapse>

      <a-form-item
        name="gerente"
        label="Gerente aprovador"
        :rules="[
          {
            message: 'Gerente aprovador é obrigatório',
            required: true,
            trigger: 'change',
            type: 'object',
          },
        ]"
      >
        <GqlSelect
          v-model:value="model.gerente"
          :query="gerentesSelect"
          placeholder="Selecione o gerente"
        />
      </a-form-item>

      <a-form-item label="Observação" name="observacao">
        <a-textarea v-model:value="model.observacao" :rows="4" />
      </a-form-item>
    </template>
  </CompromissoForm>
</template>
